export const APP_ENV = {
  TARGET: import.meta.env.VITE_PUBLIC_TARGET,
  FRONTMAN_ENDPOINT: import.meta.env.VITE_PUBLIC_FRONTMAN_ENDPOINT,
  LOG_COLLECTOR_URL: import.meta.env.VITE_PUBLIC_LOG_COLLECTOR_URL,
  LOG_COLLECTOR_TOKEN: import.meta.env.VITE_PUBLIC_LOG_COLLECTOR_TOKEN,
  SPINNER_CDN_URL: import.meta.env.VITE_SPINNER_CDN_BASE_URL,
};
